package com.essntl.features.area.domain.usecase

import com.essntl.features.area.domain.model.AreaModel
import com.essntl.features.area.domain.repository.AreaRepository
import org.koin.core.annotation.Single

@Single
class AddEditAreaUseCase(
    private val areaRepository: AreaRepository,
) {
    private suspend fun performAreaCheck(
        area: AreaModel,
        call: suspend () -> Result<AreaModel>,
    ): Result<AreaModel> {
        val areaExists = areaRepository
            .getCountAreasByName(area.name.orEmpty())
            .getOrNull()?.toInt()

        if (areaExists != 0)
            return Result.failure(Exception("This area is already added, please add a new one."))

        val response = call()

        return response
    }

    suspend fun insertArea(
        area: AreaModel,
    ): Result<AreaModel> =
        performAreaCheck(area) {
            areaRepository.insert(area)
        }

    suspend fun updateArea(
        area: AreaModel,
    ): Result<AreaModel> =
        performAreaCheck(area) {
            areaRepository.update(area)
        }
}